import { STATSIG_EXPERIMENTS_CONFIG } from '@src/config/statsig-experiments.config'
import { STATSIG_EXPERIMENTS, useStatsigExperiment } from '@src/experiments/statsig-integration'
import { COLLECTION_SLUGS_WITH_NEW_SORT } from '@src/pages/[...slug]/components/collection/collection.constants'

import { PRODUCT_SORT_VALUES } from '../constants/product'

export default function useNewCollectionSort(slug: string) {
  const { experimentBucket, init } = useStatsigExperiment(STATSIG_EXPERIMENTS.CLP_SORT)
  useStatsigExperiment(STATSIG_EXPERIMENTS.TESTING_A_A_A)

  const showNewSortCollection = COLLECTION_SLUGS_WITH_NEW_SORT.some(clp => slug.includes(clp))
  if (showNewSortCollection && experimentBucket) {
    if (experimentBucket === STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.CLP_SORT].buckets?.groupA)
      return { init, baseSortBy: PRODUCT_SORT_VALUES.CLP_RANK }
    else if (experimentBucket === STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.CLP_SORT].buckets?.groupB)
      return { init, baseSortBy: PRODUCT_SORT_VALUES.ADJ_REVENUE }
  }
  return { init, baseSortBy: PRODUCT_SORT_VALUES.FEATURED }
}
